import React from "react";
import { Row, Col, Typography } from "antd";

const { Title, Text } = Typography;

const Footer = () => {
  const footerLinks = [
    {
      title: "购物指南",
      links: ["购物流程", "会员介绍", "生活旅行", "常见问题", "联系客服"],
    },
    {
      title: "配送方式",
      links: ["免运费政策", "海外配送", "EMS", "211限时达", "售后政策"],
    },
    {
      title: "支付方式",
      links: ["货到付款", "在线支付", "分期付款", "邮局汇款", "公司转账"],
    },
    {
      title: "关于我们",
      links: ["关于我们", "联系我们", "合作招商", "商家帮助", "营销中心"],
    },
  ];

  return (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-service-links" style={{ textAlign: "center" }}>
          <Row gutter={[40, 32]} justify="center">
            {footerLinks.map((column, index) => (
              <Col xs={12} sm={6} key={index}>
                <div className="footer-column" style={{ textAlign: "center" }}>
                  <Title level={4}>{column.title}</Title>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {column.links.map((link, linkIndex) => (
                      <li key={linkIndex} style={{ margin: "8px 0" }}>
                        <span href="#" style={{ display: "inline-block" }}>
                          {link}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="footer-bottom" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "20px 0"
        }}>
          <div className="footer-info" style={{ marginBottom: "15px" }}>
            <p>
              <Text type="secondary">
                © 2023 Deal一下 版权所有 | 大小杂物，只要Deal一下
              </Text>
            </p>
            <p className="footer-links">
              <span href="#">法律声明</span>
              <span className="separator">|</span>
              <span href="#">隐私政策</span>
              <span className="separator">|</span>
              <span href="#">用户协议</span>
              <span className="separator">|</span>
              <span href="#">网站地图</span>
            </p>
          </div>

          {/* 联系方式 */}
          <div className="footer-contact" style={{ textAlign: "center" }}>
            <p>
              客服热线：<Text type="warning">400-888-8888</Text>
            </p>
            <p>服务时间：周一至周日 9:00-21:00</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;